import React from 'react';

export const ZoneLocality = ({
  zoneInLocality,
  handleLocality,
  selectedLocalityIds = [],
}) => {
  const selectedIds = selectedLocalityIds || [];
  return (
    <div className="property-filter-block">
      {zoneInLocality && (
        <label className="property-details-label">Locality</label>
      )}
      <div className="property-pill-grid">
        {zoneInLocality &&
          React.Children.toArray(
            zoneInLocality?.map((locality) => (
              <button
                type="button"
                className={`property-pill ${
                  selectedIds.some((id) => id == locality?.id)
                    ? 'property-pill--active'
                    : ''
                }`}
                onClick={handleLocality}
                data-locality={locality?.id}
              >
                {locality?.text}
              </button>
            )),
          )}
      </div>
    </div>
  );
};
